import { Card, pn, Stack, ValidationErrors } from "@compass/core";
import {
  StaffFilter as StaffFilterModel,
  StaffReportServiceSummaryRequest,
  StaffReportServiceSummaryResource,
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { ServiceSummaryDisplay } from "./ServiceSummaryDisplay";
import { StaffFilter } from "pages/staff/staff/StaffFilter";
import { StaffServiceFilter } from "pages/staff/staff-services/StaffServiceFilter";

export const ServiceSummaryRequest = (props: {
  initialized: boolean;
  request: StaffReportServiceSummaryRequest;
  setRequest: (value: StaffReportServiceSummaryRequest) => void;
  globalCommonFilter: StaffFilterModel;
  setGlobalCommonFilter: (value: StaffFilterModel) => void;
  validationErrors: ValidationErrors;
}) => {
  const [resource, setResource] = useState<StaffReportServiceSummaryResource>({});

  useEffect(() => {
    if (props.initialized) {
      ApiService.staffReports.getServiceSummaryRequest().then((response) => {
        props.setRequest(response);
      });

      ApiService.staffReports.getServiceSummaryResource().then((response) => {
        setResource(response);
      });
    }
  }, [props.initialized]);

  return (
    <Stack spacing="lg">
      <Card header="Common Filter">
        <StaffFilter
          filter={props.globalCommonFilter || ({} as StaffFilterModel)}
          setFilter={props.setGlobalCommonFilter}
        />
      </Card>

      <Card header="Service Filter">
        <StaffServiceFilter
          filter={props.request.staffServiceFilter || {}}
          setFilter={(filter) =>
            props.setRequest(
              produce(props.request, (draft) => {
                draft.staffServiceFilter = filter;
              })
            )
          }
        />
      </Card>

      <ServiceSummaryDisplay
        display={props.request.display || {}}
        setDisplay={(display) =>
          props.setRequest(
            produce(props.request, (draft) => {
              draft.display = display;
            })
          )
        }
        resource={resource.display || {}}
        validationErrors={props.validationErrors[pn<StaffReportServiceSummaryRequest>("display")] || {}}
      />
    </Stack>
  );
};
